<template>
    <router-link :to="banner.link" class="t-banner-native" :class="{_vertical: isVertical}">
        <img :src="banner.img" alt="">
    </router-link>
</template>

<script>
    export default {
        name: "banner-native",
        props: ['banner', 'isVertical'],
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/lk/banner-native/banner-native.vue